import { Environment } from 'react-relay';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';
import { getRedirectDestination } from './getRedirectDestination';
import { loginMutation } from '../authModal/authentication/login/loginMutation';
import {
    trackEmailLoginLinkComplete,
    trackVerificationFailedModalDisplayed,
} from '../authModal/authentication/authTracking';

const { EMAIL_LINK_LOGIN_RESEND_EMAIL_FLOW } = authModalLoader.constants;

export const loginUserWithEmailLoginToken = async (
    environment: Environment,
    emailLoginToken: string,
    refetchViewer: () => void
): Promise<void> => {
    try {
        await loginMutation(
            environment,
            {
                email: null,
                password: null,
                emailLoginToken,
            },
            {}
        );

        // TODO add tracking for stale user once labels are approved
        trackEmailLoginLinkComplete();

        const destination = getRedirectDestination();
        if (destination) {
            window.location.href = handleLocaleUrl(destination, GLOBAL_CLIENT_ONLY_LOCALE);
        } else {
            const searchParams = new URLSearchParams(window.location.search);
            const hasEmailLoginToken = searchParams.has('emailLoginToken');
            if (hasEmailLoginToken) {
                searchParams.delete('emailToken');
                searchParams.delete('emailLoginToken');
                searchParams.delete('email');
                window.location.replace(
                    handleLocaleUrl(
                        `${window.location.pathname}?${searchParams.toString()}`,
                        GLOBAL_CLIENT_ONLY_LOCALE
                    )
                );
            } else {
                refetchViewer();
            }
        }
    } catch (error) {
        const email = new URLSearchParams(window.location.search).get('email');
        // TODO add tracking for stale user once labels are approved
        trackVerificationFailedModalDisplayed();
        authModalLoader.show({
            action: authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
            email,
            flow: EMAIL_LINK_LOGIN_RESEND_EMAIL_FLOW,
        });
    }
};
